import {Button} from 'antd';
import {Link} from 'react-router-dom';
import styles from './index.module.scss';

export interface ITabElement {
  link: string;
  title: string;
}

export interface ITabsProps {
  tabs: ITabElement[];
}

const Tabs = ({tabs}: ITabsProps) => (
  <div className={styles.tabsWrapper}>
    {tabs.map(tab => (
      <Link key={tab.title} title={tab.title} to={tab.link}>
        <Button size='large' type='primary' htmlType='button'>
          {tab.title}
        </Button>
      </Link>
    ))}
  </div>
);

export default Tabs;
